import { MjmlColumn, MjmlSection, MjmlText } from "@faire/mjml-react";
import {
  EmailFormat,
  EmailHeaderType,
  Section,
  SharedProps,
} from "@redotech/redo-model/email-builder";
import * as classNames from "classnames";
import { memo, useEffect, useState } from "react";

export type HeaderState = Section.Header & SharedProps;

export const EmailHeader = memo(function EmailHeader(props: HeaderState) {
  const src =
    props.headerType === EmailHeaderType.LOGO
      ? props.team.settings.brandKit?.images.logoUrl
      : props.imageUrl;
  const height =
    props.headerType === EmailHeaderType.LOGO
      ? props.logoHeight
      : props.imageHeight || 49;
  const marginLeft = props.layout !== "left" ? "auto" : "0";
  const marginRight = props.layout !== "right" ? "auto" : "0";
  const isBuilder = props.isBuilder;

  const [refreshKey, setRefreshKey] = useState(0);
  useEffect(() => {
    if (props.format !== EmailFormat.AMP) return;
    setRefreshKey(refreshKey + 1);
    // FIXME
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props]);

  // no MjmlImage because it doesn't support AMP email special cases :(
  const imageContent =
    props.format === EmailFormat.AMP ? (
      <div
        className={classNames("amp-img-container", props.layout)}
        style={{
          height: `${height}px`,
          position: "relative",
          marginLeft,
          marginRight,
        }}
      >
        <amp-img height={height} layout="fill" src={src} />
      </div>
    ) : (
      <img
        alt={props.altText}
        height={height}
        src={src}
        style={{
          height: `${height}px`,
          width: "auto",
          maxWidth: "100%",
          marginLeft,
          marginRight,
        }}
      />
    );

  const padding = props.sectionPadding;

  return (
    <MjmlSection
      backgroundColor={props.sectionColor || "#ffffff"}
      key={refreshKey}
      paddingBottom={padding.bottom}
      paddingLeft={padding.left}
      paddingRight={padding.right}
      paddingTop={padding.top}
      textAlign={props.layout || "center"}
    >
      <MjmlColumn>
        <MjmlText align={props.layout || "center"}>
          {[EmailHeaderType.LOGO, EmailHeaderType.IMAGE].includes(
            props.headerType,
          ) &&
            (!isBuilder ? (
              <a
                href={
                  props.clickthroughUrl
                    ? props.utm.applyToUrl(props.clickthroughUrl)
                    : props.utm.applyToUrl(props.team.storeUrl)
                }
              >
                {imageContent}
              </a>
            ) : (
              imageContent
            ))}
          {props.headerType === EmailHeaderType.TEXT && (
            <p
              style={{
                fontSize: `${props.fontSize}px`,
                fontFamily: props.fontFamily,
                color: props.textColor,
              }}
            >
              {props.text}
            </p>
          )}
        </MjmlText>
      </MjmlColumn>
    </MjmlSection>
  );
});
